import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=240990f9&scoped=true&"
import script from "./WalletInfo.vue?vue&type=script&lang=ts&"
export * from "./WalletInfo.vue?vue&type=script&lang=ts&"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=240990f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240990f9",
  null
  
)

export default component.exports